import React from "react";
import { LABELS } from "./OrderSummaryConstants";
import { OrderHeaderProps } from "./types";

const OrderHeader: React.FC<OrderHeaderProps> = ({ orderId, customerName }) => (
  <div className="mb-3 text-lg">
    <p className="mb-1">
      <strong>{LABELS.ORDER_ID}:</strong> {orderId ?? "N/A"}
    </p>
    <p>
      <strong>{LABELS.CUSTOMER_NAME}:</strong> {customerName ?? "N/A"}
    </p>
  </div>
);

export default OrderHeader;
